import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { OrderHeadDeliveryFormGroup } from '../../order-head-edit/order-head-edit.component';
import { OrderHeadGet } from '@app/services/orderhead.service';
import { PickJobGroupItem } from '@app/services/pick-job-group.service';
import { DeliveryMethodItem } from '@app/services/logistic.service';

@Component({
    selector: 'tt-order-head-delivery-form',
    templateUrl: './order-head-delivery-form.component.html',
    styleUrls: ['./order-head-delivery-form.component.css'],
})
export class OrderHeadDeliveryFormComponent {
    @Input()
    public get?: OrderHeadGet;

    @Input()
    public form?: FormGroup<OrderHeadDeliveryFormGroup>;

    @Input()
    public deliveryMethods: DeliveryMethodItem[] = [];

    @Input()
    public pickJobGroups: PickJobGroupItem[] = [];

    public get showOfferFields() {
        return this.get?.ordertype_id === '1' || this.hasOrderOffer;
    }

    public get offerFieldsReadonly() {
        return this.get?.ordertype_id !== '1' && this.hasOrderOffer;
    }

    private get hasOrderOffer() {
        return +(this.get?.order_offer_no ?? 0) > 0;
    }
}
